import axios from "axios";
import { LOGIN, REGISTER, LOGIN_AD, SYSTEM_NOTIFICATION_LIST, SYSTEM_NOTIFICATION_MARK_AS_READ, FORGOT_PASSWORD, DECRYPT_KEY, RESET_PASSWORD, APP_SETTINGS, CAPTCHA_VERIFICATION,SYSTEM_NOTIFICATION_CLEAR_ALL, SYSTEM_NOTIFICATION_COUNT } from '../../constants/api';
import { getLocalStorageValue } from './../utils/local-storage';
import { MESSAGE_FOR_REGISTERED, USER, MESSAGE_FOR_FORGOT_PASSWORD, RESET_PASSWORD_SUCCESS } from 'src/constants/NotificationMessageConstant';
import { ShowException, ShowSuccessOrError } from '../utils/tostar';
import { AuthenticationContext } from 'react-adal';
import { SYNC_SURVEY_GET_USER_COUNTRIES_KEY } from 'src/constants/constants';

const noAuth = ['users/authenticate', 'users/authenticate-ad', 'users/app-settings'];

axios.interceptors.request.use(
    (config: any) => {
        const isAuthRequired: any = noAuth.find((item: any) => (config.url.includes(item)));
        if (!isAuthRequired) {
            const user = getLocalStorageValue('user');
            if (user) {
                config.headers.Authorization = 'bearer ' + user.token;
            }
        }
        return config;
    },
    err => {
        return err;
    }
);

export const registerUserCall = (data: any) => {
    return axios.post(REGISTER, data.payload)
        .then(resp => {
            ShowSuccessOrError(USER + MESSAGE_FOR_REGISTERED, resp);
            return resp;
        }, err => {
            ShowException(err);
            return err;
        })
}

export const loginUserCall = (data: any) => {
    return axios.post(LOGIN, data)
        .then(resp => {
            return resp;
        }, err => {
            ShowException(err);
            return err;
        });
}

export const verifyCaptchaCall = (data: any) => {
    return axios.post(CAPTCHA_VERIFICATION, data)
        .then(resp => {
            return resp;
        }, err => {
            ShowException(err);
            return err;
        });
}

export const loginUserAdCall = (data: any) => {
    return axios.post(LOGIN_AD, data)
        .then(resp => {
            return resp;
        }, err => {
            ShowException(err);
            const loggedInUser = getLocalStorageValue('user');
            if (loggedInUser) {
                localStorage.removeItem(`UserId_${loggedInUser.id}_${SYNC_SURVEY_GET_USER_COUNTRIES_KEY}`);
            }
            localStorage.removeItem('user');
            
            getAdalConfig().then((adalConfig) => {
                if (adalConfig) {
                    const authContext = new AuthenticationContext(adalConfig)
                    setTimeout(() => {
                        authContext.logOut();
                    }, 5000)
                }
            });
            
            return err;
        });
}

export const getAdalConfig = () => {
    return axios.get(APP_SETTINGS)
        .then(resp => {
            let adalConfig;
            if (resp && resp.data.success && resp.data.payload) {
                const payload = resp.data.payload;
                const azureAdInstance = payload.azureAdInstance.endsWith('/') ? payload.azureAdInstance : `${payload.azureAdInstance}/`;
                adalConfig = {
                    tenant: payload.azureAdTenantId,
                    clientId: payload.azureAdClientId,
                    endpoints: {
                        api: azureAdInstance + payload.azureAdTenantId
                    },
                    postLogoutRedirectUri: window.location.origin + '/login',
                    redirectUri: window.location.origin + '/login',
                    cacheLocation: 'sessionStorage',
                };
            }
            return adalConfig;
        }, err => {
            ShowException(err);
            return err;
        });
}

export const getAppSettingsCall = () => {
    return axios.get(APP_SETTINGS)
        .then(resp => {
            let appSettings;
            if (resp && resp.data.success && resp.data.payload) {
                appSettings = resp.data.payload;
            }
            return appSettings;
        }, err => {
            ShowException(err);
            return err;
        });
}

export const getNotifications = () => {
    return axios.get(SYSTEM_NOTIFICATION_LIST)
        .then(resp => {
            return resp;
        }, err => {
            ShowException(err);
            return err;
        });
}

export const markAsReadNotification = (data: any) => {
    return axios.post(SYSTEM_NOTIFICATION_MARK_AS_READ + '/' + data)
        .then(resp => {
            return resp;
        }, err => {
            ShowException(err);
            return err;
        });
}

export const clearAllNotification=()=>{
    return axios.post(SYSTEM_NOTIFICATION_CLEAR_ALL)
    .then(resp => {
        return resp;
    }, err => {
        ShowException(err);
        return err;
    });
}

export const forgotPasswordCall = (data: any) => {
    return axios.post(FORGOT_PASSWORD + '/' + data)
        .then(resp => {
            ShowSuccessOrError(MESSAGE_FOR_FORGOT_PASSWORD, resp);
            return resp;
        }, err => {
            ShowException(err);
            return err;
        });
}

export const decrypTextCall = (data: any) => {
    return axios.post(DECRYPT_KEY, data)
        .then(resp => {
            // ShowSuccessOrError(USER + MESSAGE_FOR_FORGOT_PASSWORD, resp);
            return resp;
        }, err => {
            ShowException(err);
            return err;
        });
}

export const resetPasswordCall = (data: any) => {
    return axios.put(RESET_PASSWORD + '/', data)
        .then(resp => {
            ShowSuccessOrError(USER + RESET_PASSWORD_SUCCESS, resp);
            return resp;
        }, err => {
            ShowException(err);
            return err;
        });
}

export const getNotificationsCount = () => {
    return axios.get(SYSTEM_NOTIFICATION_COUNT)
        .then(resp => {
            return resp;
        }, err => {
            ShowException(err);
            return err;
        });
}


// WEBPACK FOOTER //
// ./src/effects/api/api.userAuth.tsx